//import { uploadBase64 } from 'helpers/fb-storage';

import { objectToFormData } from 'helpers/utils';

export const create = async data => {
 console.log(data, 'datos que seran enviados al servidor');
 return await objectToFormData(data);
};

export const register = data => {
 const formData = new FormData();
 const inputFiles = document.getElementsByClassName('logo')[0].files;

 Object.entries(data).map(e => formData.append([e[0]], typeof e[1] === 'object' ? JSON.stringify(e[1]) : e[1]));

 for (var i = 0; i < inputFiles.length; i++) {
  formData.append('logo', inputFiles[i]);
 }

 return formData;
};
